// extracted by mini-css-extract-plugin
module.exports = {"button":"BuyNow_button__2cYYi","linkButton":"BuyNow_linkButton__2ic7N"};